import { AlertTriangle, CheckCircle2 } from "lucide-react";

import { cn } from "@/app/handlers/cn.utils";

interface BaselineItemDisplayProps {
	label: string;
	description: string;
	status: "MEET" | "PARTIAL" | "MISSING";
}

export const BaselineItemDisplay = ({ label, description, status }: BaselineItemDisplayProps) => {
	const isMet = status === "MEET";
	return (
		<div className="flex items-start gap-2">
			{isMet ? (
				<CheckCircle2 className="w-4 h-4 text-green-600 mt-0.5 shrink-0" />
			) : (
				<AlertTriangle className="w-4 h-4 text-yellow-600 mt-0.5 shrink-0" />
			)}
			<div>
				<p className={cn("text-sm font-semibold leading-none mb-1", isMet ? "text-green-700" : "text-yellow-700")}>
					{label}
				</p>
				<p className="text-sm text-gray-700 leading-tight">{description}</p>
			</div>
		</div>
	);
};

export default BaselineItemDisplay;
